export type FailedRequestBody = { errors?: unknown; error?: unknown; message?: unknown };

export const allowlistedResponseFields = (data?: FailedRequestBody): Record<string, string> => ({
  ...(typeof data?.error === "string" ? { response_error: data.error } : {}),
  ...(typeof data?.message === "string" ? { response_message: data.message } : {}),
});
